import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      static u2g(level, marker, loggerName, message, cause, payload) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        var $this = createThis(this);
        $this.n2g_1 = level;
        $this.o2g_1 = marker;
        $this.p2g_1 = loggerName;
        $this.q2g_1 = message;
        $this.r2g_1 = cause;
        $this.s2g_1 = payload;
        return $this;
      }
      static v2g(level, marker, loggerName, eventBuilder) {
        return this.u2g(level, marker, loggerName, eventBuilder.r2f_1, eventBuilder.s2f_1, eventBuilder.t2f_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.n2g_1.toString() + ', marker=' + toString(this.o2g_1) + ', loggerName=' + this.p2g_1 + ', message=' + this.q2g_1 + ', cause=' + toString(this.r2g_1) + ', payload=' + toString(this.s2g_1) + ')';
      }
      hashCode() {
        var result = this.n2g_1.hashCode();
        result = imul(result, 31) + (this.o2g_1 == null ? 0 : hashCode(this.o2g_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.p2g_1) | 0;
        result = imul(result, 31) + (this.q2g_1 == null ? 0 : getStringHashCode(this.q2g_1)) | 0;
        result = imul(result, 31) + (this.r2g_1 == null ? 0 : hashCode(this.r2g_1)) | 0;
        result = imul(result, 31) + (this.s2g_1 == null ? 0 : hashCode(this.s2g_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.n2g_1.equals(tmp0_other_with_cast.n2g_1))
          return false;
        if (!equals(this.o2g_1, tmp0_other_with_cast.o2g_1))
          return false;
        if (!(this.p2g_1 === tmp0_other_with_cast.p2g_1))
          return false;
        if (!(this.q2g_1 == tmp0_other_with_cast.q2g_1))
          return false;
        if (!equals(this.r2g_1, tmp0_other_with_cast.r2g_1))
          return false;
        if (!equals(this.s2g_1, tmp0_other_with_cast.s2g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
